import Vue from "vue";
import VueRouter from "vue-router";
import { setLoading } from "@/utils/plugins/loadingState";
import aboutRoutes from "./aboutRoutes";
import challengeRoutes from "./challengeRoutes";
import chapterRoutes from "./chapterRoutes";
import eventRoutes from "./eventRoutes";
import resourcesArticleRoutes from "./resourcesArticleRoutes";
import resourcesFooterRoutes from "./resourcesFooterRoutes";
import resourcesIndexRoutes from "./resourcesIndexRoutes";
import resourcesOrganizerRoutes from "./resourcesOrganizerRoutes";
import seriesRoutes from "./seriesRoutes";
import userRoutes from "./userRoutes";

import adminGuard from "../utils/auth/adminGuard";
import homeGuard from "@/utils/auth/homeGuard";

import accountFinishedCheck from "../utils/auth/accountFinishedCheck";
import provisionalLoginCheck from "../utils/auth/provisionalLoginCheck";
//import maintenanceCheck from "../utils/auth/maintenanceCheck";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    beforeEnter: homeGuard
  },
  ...aboutRoutes,
  ...challengeRoutes,
  ...chapterRoutes,
  ...eventRoutes,
  ...resourcesArticleRoutes,
  ...resourcesFooterRoutes,
  ...resourcesIndexRoutes,
  ...resourcesOrganizerRoutes,
  ...seriesRoutes,
  ...userRoutes,
  {
    path: "/a",
    name: "AdminIndex",
    beforeEnter: adminGuard,
    component: () => import("@/screensAdmin/AdminIndex.vue")
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/screens/Maintenance.vue")
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/screens/NotFoundPage.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach(accountFinishedCheck);
router.beforeEach(provisionalLoginCheck);
//router.beforeEach(maintenanceCheck); //comment this line out (and deploy) when we aren't in maintenance mode

router.beforeEach(async (to, from, next) => {
  setLoading(true);
  next();
});

router.afterEach(() => {
  setLoading(false);
});

export default router;
